<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <div style="float: right">
        <md-button class="md-primary" :disabled="isDisabled" @click="exportData()">
          Export
        </md-button>
      </div>
      
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>group</md-icon>
          </div>
          <h4 class="title">Parents</h4>
        </md-card-header>

        <md-card-content>
          <!-- FILTERS SECTION -->
          <div class="md-layout">
            <!-- From Date -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-field>
                <md-datepicker v-model="fromDate" md-immediately>
                  <label>From Date</label>
                </md-datepicker>
              </md-field>
            </div>

            <!-- To Date -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-field>
                <md-datepicker v-model="toDate" md-immediately>
                  <label>To Date</label>
                </md-datepicker>
              </md-field>
            </div>

            <!-- Email -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-field>
                <label>Email</label>
                <md-input type="text" v-model="email"></md-input>
              </md-field>
            </div>

            <!-- Phone Number -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-field>
                <label>Phone Number</label>
                <md-input type="text" v-model="phoneNumber"></md-input>
              </md-field>
            </div>

            <!-- Device Purchase Status -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-field>
                <label>Device Purchase Status</label>
                <md-select v-model="devicePurchaseFilter">
                  <md-option value="">All</md-option>
                  <md-option value="Completed">Completed</md-option>
                  <md-option value="Incomplete">Incomplete</md-option>
                </md-select>
              </md-field>
            </div>

            <!-- Tag Filter -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-field>
                <label>Tag</label>
                <md-select v-model="tagFilter">
                  <md-option value="">All</md-option>
                  <md-option v-for="t in uniqueTags" :key="t" :value="t">
                    {{ t }}
                  </md-option>
                </md-select>
              </md-field>
            </div>

            <!-- SMS/Phone Call Permission Filter -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-field>
                <label>SMS/Call Permission</label>
                <md-select v-model="smsPhoneCallFilter">
                  <md-option value="">All</md-option>
                  <md-option value="true">Enabled</md-option>
                  <md-option value="false">Disabled</md-option>
                </md-select>
              </md-field>
            </div>

            <!-- Search Button -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-button 
                class="md-primary md-raised" 
                :disabled="isDisabled" 
                @click="kidsParentsList()"
                style="margin-top: 10px; width: 100%;"
              >
                <md-icon>search</md-icon> Search
              </md-button>
            </div>

            <!-- Clear Filters Button -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-button 
                class="md-accent" 
                @click="clearFilters()"
                style="margin-top: 10px; width: 100%;"
              >
                <md-icon>clear</md-icon> Clear Filters
              </md-button>
            </div>
          </div>

          <hr style="margin: 20px 0;">

          <!-- TABLE -->
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <div style="margin-left: auto;">
                <p class="card-category" style="margin: 0;">
                  Total: <strong>{{ total }}</strong> parents
                </p>
              </div>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <!-- Email -->
              <md-table-cell md-label="Email" md-sort-by="email">
                <a href="javascript:void(0)" @click="ByPassUserLogin(item.email)">
                  {{ item.email }}
                </a>
                <span class="badge badge-info" v-if="item.delegatedAccessUser == true">
                  Delegated
                </span>
                <div v-if="item.name != item.email" style="font-size: 12px; color: #666;">
                  {{ item.name }}
                </div>
              </md-table-cell>

              <!-- Phone Number -->
              <md-table-cell md-label="Phone" md-sort-by="phone_number">
                <span v-if="item.country_code || item.phone_number">
                  {{ item.country_code }} {{ item.phone_number }}
                </span>
                <span v-else style="color: #999;">—</span>
              </md-table-cell>

              <!-- Products -->
              <md-table-cell md-label="Products">
                {{ getProductNames(item.cartData) }}
              </md-table-cell>

              <!-- Device Purchase -->
              <md-table-cell md-label="Device Purchase" md-sort-by="devicePurchaseStatus">
                <span
                  :class="[
                    'badge',
                    item.devicePurchaseStatus === 'Completed' 
                      ? 'badge-success' 
                      : 'badge-danger'
                  ]"
                >
                  {{ item.devicePurchaseStatus }}
                </span>
              </md-table-cell>

              <!-- Review Request -->
              <md-table-cell md-label="Review Request" md-sort-by="reviewRequestSentCount">
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span class="badge badge-primary">{{ item.reviewRequestSentCount || 0 }}</span>
                  <button 
                    class="action-btn action-btn-sm" 
                    @click="$router.push({ 
                      path: '/kid/review-request', 
                      query: { email: item.email }
                    })"
                  >
                    Request
                  </button>
                </div>
              </md-table-cell>

              <!-- Tag -->
              <md-table-cell md-label="Tag">
                <div class="tag-box">
                  <input 
                    v-model="item.tag" 
                    placeholder="Add tag"
                    class="tag-input-with-btn"
                    @keyup.enter="updateTag(item)"
                  />
                  <button class="tag-btn-inside" @click="updateTag(item)">
                    <md-icon style="font-size: 14px;">check</md-icon>
                  </button>
                </div>
              </md-table-cell>

              <!-- SMS/Phone Call Permission -->
              <!-- SMS/Phone Call Permission -->
              <md-table-cell md-label="SMS/Call Access">
                <div style="display: flex; gap: 12px; justify-content: center;">
                  <md-checkbox 
                    v-model="item.canReadSMSAndPhoneCall" 
                    @change="updateSMSPhoneCallPermission(item)"
                    class="md-primary"
                  />
                </div>
              </md-table-cell>

              <!-- Created -->
              <md-table-cell md-label="Created" md-sort-by="created_at">
                {{ HumanReadableDateFormat(item.created_at, true) }}
              </md-table-cell>
            </md-table-row>
          </md-table>

        </md-card-content>

        <!-- Pagination Footer -->
        <md-card-actions md-alignment="space-between">
          <div>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>

      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Swal from "sweetalert2";
import UsersDataService from "../../services/SuperAdmin/UsersDataService";

export default {
  components: { Pagination },

  computed: {
    queriedData() {
      return this.tableData.slice(this.from, this.to);
    },

    uniqueTags() {
      const tags = this.tableData.map(t => t.tag).filter(Boolean);
      return [...new Set(tags)];
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) highBound = this.total;
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    total() {
      return this.tableData.length;
    }
  },

  data() {
    return {
      isDisabled: false,
      currentSort: "created_at",
      currentSortOrder: "desc",

      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100],
        total: 0,
      },

      tableData: [],

      // Filters
      email: "",
      phoneNumber: "",
      fromDate: "",
      toDate: null,
      devicePurchaseFilter: "",
      tagFilter: "",
      smsPhoneCallFilter: "",
    };
  },

  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy]?.toString().localeCompare(b[sortBy]?.toString());
        }
        return b[sortBy]?.toString().localeCompare(a[sortBy]?.toString());
      });
    },

    kidsParentsList() {
      this.isDisabled = true;
      
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        email: this.email,
        phone_number: this.phoneNumber,
        devicePurchaseStatus: this.devicePurchaseFilter,
        tag: this.tagFilter,
        canReadSMSAndPhoneCall: this.smsPhoneCallFilter,
      };

      UsersDataService.kidsParentsList(data)
        .then((response) => {
          this.tableData = response.data.data;
          this.isDisabled = false;
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || "Error fetching data");
          this.isDisabled = false;
        });
    },

    clearFilters() {
      this.email = "";
      this.phoneNumber = "";
      this.fromDate = "";
      this.toDate = null;
      this.devicePurchaseFilter = "";
      this.tagFilter = "";
      this.smsPhoneCallFilter = "";
      this.kidsParentsList();
    },

    updateTag(item) {
      UsersDataService.updateParentTag({
        userId: item._id,
        tag: item.tag
      })
        .then(() => {
          this.$toast.success("Tag updated successfully");
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || "Error updating tag");
        });
    },

    updateSMSPhoneCallPermission(item) {
      UsersDataService.updateCanReadSMSAndPhoneCall({
        userId: item._id,
        email: item.email,
        canReadSMSAndPhoneCall: item.canReadSMSAndPhoneCall
      })
        .then((response) => {
          this.$toast.success(response.data.respones_msg);
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || "Error updating permission");
          // Revert checkbox on error
          item.canReadSMSAndPhoneCall = !item.canReadSMSAndPhoneCall;
        });
    },

    ByPassUserLogin(email) {
      UsersDataService.ByPassUserLogin({ email })
        .then((response) => {
          window.open(
            "https://parent.mywingio.com?token=" + response.data.data.token,
            "_blank"
          );
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || "Login failed");
        });
    },

    getProductNames(cartData) {
      if (!cartData || !Array.isArray(cartData)) return "—";
      return cartData
        .map((c) => c?.productDetail?.name || "Unknown Product")
        .join(", ");
    },

    async exportData() {
      if (this.tableData.length > 0) {
        let exportData = [];
        for await (let data of this.tableData) {
          exportData.push([
            data.email,
            data.name,
            `${data.country_code || ''} ${data.phone_number || ''}`.trim(),
            data.devicePurchaseStatus,
            data.reviewRequestSentCount || 0,
            data.tag || '',
            data.canReadSMSAndPhoneCall ? 'Yes' : 'No',
            data.created_at
          ]);
        }
        this.DownloadSampleImportFile(exportData);
      } else {
        this.$toast.error("No data to export");
      }
    },

    DownloadSampleImportFile(exportData = "") {
      let csv = 'Email,Name,Phone,Device Purchase,Review Req Count,Tag,SMS/Call Access,Created On\n';
      if (exportData) {
        exportData.forEach((row) => {
          csv += row.map(field => `"${field}"`).join(',');
          csv += "\n";
        });
      }
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      if (exportData) {
        anchor.download = 'wingio-parents.csv';
      }
      anchor.click();
    },
  },

  beforeMount() {
    this.kidsParentsList();
  },

  watch: {
    devicePurchaseFilter() {
      this.pagination.currentPage = 1;
    },
    tagFilter() {
      this.pagination.currentPage = 1;
    },
    smsPhoneCallFilter() {
      this.pagination.currentPage = 1;
    },
  }
};
</script>

<style scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

::v-deep .md-table-cell {
  word-wrap: break-word;
  white-space: normal;
  vertical-align: top;
  padding: 12px 8px;
}

.tag-box {
  position: relative;
  width: 150px;
}

.tag-input-with-btn {
  width: 100%;
  height: 32px;
  padding: 5px 40px 5px 8px;
  font-size: 13px;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition: border-color 0.3s;
}

.tag-input-with-btn:focus {
  outline: none;
  border-color: #8e24aa;
}

.tag-btn-inside {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  height: 26px;
  width: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #8e24aa;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

.tag-btn-inside:hover {
  background: #6a1b9a;
}

.action-btn {
  padding: 6px 12px;
  font-size: 12px;
  background: #8e24aa;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

.action-btn:hover {
  background: #6a1b9a;
}

.action-btn-sm {
  padding: 4px 8px;
  font-size: 11px;
}

.badge {
  display: inline-block;
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 12px;
  text-transform: uppercase;
}

.badge-success {
  background: #4caf50;
  color: white;
}

.badge-danger {
  background: #f44336;
  color: white;
}

.badge-info {
  background: #2196f3;
  color: white;
  margin-left: 6px;
}

.badge-primary {
  background: #8e24aa;
  color: white;
}
</style>